import { Typography } from "@mui/material";
import { Dialog } from "components/Dialog";

/**
 * Detach a bill of lading. Lighter consequences than DetachManifestDialog's:
 * there is no auto-match suppression to mention, because nothing attaches a
 * bill of lading automatically in the first place.
 */
export function DetachBillOfLadingDialog({
  documentNumber,
  detaching,
  onConfirm,
  onClose,
}: {
  documentNumber: string | null;
  detaching: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      title="Detach this bill of lading?"
      primaryActionButtonProps={{
        saveText: "Detach document",
        loading: detaching,
        onClick: onConfirm,
      }}
    >
      <Typography variant="body2">
        {documentNumber ? `Bill of lading ${documentNumber}` : "This bill of lading"} will be
        unlinked. The document itself is not deleted, and this shipment&apos;s contents become
        editable again.
      </Typography>
    </Dialog>
  );
}
